import { render, staticRenderFns } from "./IngredientSort.vue?vue&type=template&id=1e114d80&"
import script from "./IngredientSort.vue?vue&type=script&lang=ts&"
export * from "./IngredientSort.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports